const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Vállalattoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Állatorvosasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Kötelező",
    },
  },
  salutation: {
    label: "Megszólítás",
    placeholder: "Válassza ki a megszólítást",
    errors: {
      required: "A megszólítás kötelező",
      invalid: "Kérjük, válasszon érvényes megszólítást",
    },
  },
  firstName: {
    label: "Keresztnév",
    placeholder: "János",
    errors: {
      authenticatedNameUpdateTrial:
        "Be van jelentkezve, a neve nem módosítható.",
      required: "A keresztnév kötelező",
      minLength: "A keresztnévnek legalább 2 karakternek kell lennie",
      maxLength: "A keresztnév legfeljebb 50 karakter lehet",
    },
  },
  lastName: {
    label: "Vezetéknév",
    placeholder: "Nagy",
    errors: {
      authenticatedNameUpdateTrial:
        "Be van jelentkezve, a neve nem módosítható.",
      required: "A vezetéknév kötelező",
      minLength: "A vezetéknévnek legalább 2 karakternek kell lennie",
      maxLength: "A vezetéknév legfeljebb 50 karakter lehet",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "janos.nagy@pelda.hu",
    description:
      "Kérjük, adjon meg egy személyes e-mail címet, ne megosztott e-mail címet.",
    prefixWarningTitle: "Megosztott postafiók észlelve",
    prefixWarningDescription:
      "Javasoljuk személyes e-mail cím használatát a jobb személyre szabott élményért",
    errors: {
      authenticatedEmailUpdateTrial:
        "Be van jelentkezve, az e-mail-címe nem módosítható.",
      required: "Az e-mail kötelező",
      invalidEmail: "Kérjük, adjon meg érvényes e-mail címet",
      emailAssociatedWithYourAccount:
        "Az e-mail címe a fiókjához van rendelve, és nem változtatható.",
    },
  },
  confirmEmail: {
    label: "E-mail megerősítése",
    placeholder: "janos.nagy@pelda.hu",
    errors: {
      authenticatedEmailUpdateTrial:
        "Be van jelentkezve, az e-mail-címe nem módosítható.",
      required: "Az e-mail megerősítése kötelező",
      invalidEmail: "Kérjük, adjon meg érvényes e-mail címet",
      emailMatchError: "Az e-mail címek nem egyeznek",
    },
  },
  password: {
    label: "Jelszó",
    placeholder: "Adja meg a jelszavát",
    errors: {
      required: "A jelszó kötelező",
    },
  },
  confirmPassword: {
    label: "Jelszó megerősítése",
    placeholder: "Erősítse meg a jelszavát",
    errors: {
      required: "A jelszó megerősítése kötelező",
      passwordMatchError: "A jelszavak nem egyeznek",
    },
  },
  addressLine1: {
    label: "Cím 1. sor",
    placeholder: "Andrássy út 123",
    errors: {
      required: "A cím 1. sora kötelező",
      minLength: "A cím 1. sorának legalább 5 karakternek kell lennie",
      maxLength: "A cím 1. sora legfeljebb 100 karakter lehet",
    },
  },
  addressLine2: {
    label: "Cím 2. sor",
    placeholder: "4. emelet B",
    errors: {
      required: "A cím 2. sora kötelező",
      maxLength: "A cím 2. sora legfeljebb 100 karakter lehet",
    },
  },
  city: {
    label: "Város",
    placeholder: "Budapest",
    errors: {
      required: "A város kötelező",
      minLength: "A városnak legalább 2 karakternek kell lennie",
      maxLength: "A város legfeljebb 50 karakter lehet",
    },
  },
  country: {
    label: "Ország",
    placeholder: "Válasszon országot",
    errors: {
      required: "Az ország megadása kötelező",
      invalid: "Kérjük, válasszon érvényes országot",
    },
  },
  state: {
    label: "Állam",
    placeholder: "Válassza ki az államot",
    errors: {
      required: "Az állam kötelező",
      invalid: "Kérjük, válasszon érvényes államot",
    },
  },
  jurisdiction: {
    label: "Engedély joghatósága",
    placeholder: "Válassza ki az engedély joghatóságát",
    errors: {
      required: "Az engedély joghatósága kötelező",
      invalid: "Kérjük, válasszon érvényes joghatóságot",
    },
  },
  zipCode: {
    label: "Irányítószám",
    placeholder: "1012",
    errors: {
      required: "Az irányítószám kötelező",
      invalid: "Kérjük, adjon meg érvényes irányítószámot",
    },
  },
  role: {
    label: "Elsődleges szerep:",
    placeholder: "Szerep kiválasztása",
    errors: {
      required: "Kérjük, válassza ki a szerepét",
      invalid: "Kérjük, válasszon érvényes szerepet",
    },
  },
  businessType: {
    label: "Vállalat típusa",
    placeholder: "Válassza ki a vállalat típusát",
    errors: {
      required: "A vállalat típusa kötelező",
      invalid: "Kérjük, válasszon érvényes vállalattípust",
    },
  },
  businessName: {
    label: "Vállalat neve",
    placeholder: "Adja meg a vállalat nevét",
    errors: {
      required: "A vállalat neve kötelező",
      minLength: "A vállalat nevének legalább 2 karakternek kell lennie",
      maxLength: "A vállalat neve legfeljebb 100 karakter lehet",
    },
  },
  businessSearch: {
    label: "Vállalatkeresés:",
    addNewAccount: "Új vállalati fiók hozzáadása",
    canNotFindBusiness: "Nem találja a vállalatát?",
    guideline:
      "Kérjük, adja meg az irányítószámát, majd válasszon az alábbi listából.",
    guidelineForNameSearch:
      "Kérjük, adja meg a vállalat teljes nevét, majd válasszon a listából.",
    placeholder: "Hol dolgozik?",
    noResults: "Nincs találat",
    searching: "Keresés...",
    selectedBusinessHeading: "Kiválasztott vállalat:",
    selectedBusinessNotCorrect: "Nem helyes?",
    selectedBusinessTryAgain: "Próbálja újra",
    selectedBusinessDismiss: "Vállalat elvetése",
    resultsFound: {
      singular: "1 vállalat találva",
      plural: "Több vállalat találva",
    },
    errors: {
      network:
        "Problémák merültek fel a vállalatkereső szolgáltatáshoz való csatlakozás során. Kérjük, próbálja újra később.",
    },
  },
  explicitConsent: {
    label:
      "A jelölőnégyzet bejelölésével hozzájárulok, hogy az Elanco marketingközleményeket küldjön nekem.",
    errors: {
      required: "A hozzájárulás megadása kötelező",
    },
  },
  explicitSmsConsent: {
    label:
      "A jelölőnégyzet bejelölésével hozzájárulok, hogy az Elanco marketingközleményeket küldjön nekem SMS-ben/szöveges üzenetben.",
    errors: {
      required: "Az SMS-hez való hozzájárulás kötelező",
    },
  },
  telephone: {
    label: "Személyes telefon",
    placeholder: "Adja meg személyes telefonszámát",
    dialCodeLabel: "Kód",
    dialCodePlaceholder: "Ország keresése…",
    errors: {
      invalid: "Kérjük, adjon meg érvényes telefonszámot.",
    },
  },
  businessTelephone: {
    label: "Vállalati telefon",
    placeholder: "Adja meg a vállalati telefonszámot",
    dialCodeLabel: "Kód",
    dialCodePlaceholder: "Ország keresése…",
    errors: {
      invalid: "Kérjük, adjon meg érvényes telefonszámot.",
    },
  },
  professionalNumber: {
    label: "Szakmai szám",
    placeholder: "1234567",
    errors: {
      required: "Kérjük, adja meg a szakmai számot",
      maxLength: "A bevitel túllépi a karakterkorlátot",
    },
  },
  addressSearch: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  businessSearchField: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  checkbox: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  combobox: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  datePicker: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  dateRange: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  dateTime: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  emailField: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  fileInput: {
    errors: {
      required: "Kérjük, válasszon fájlt",
    },
  },
  number: {
    errors: {
      required: "Kérjük, adjon meg egy számot",
      minValue: "Kérjük, adjon meg a minimálisnál nagyobb értéket",
      maxValue: "Kérjük, adjon meg a maximálisnál kisebb értéket",
    },
  },
  passwordField: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  rangeSlider: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  select: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  telephoneField: {
    errors: {
      required: "Kérjük, csak számokat adjon meg",
      invalidTelephone: "Kérjük, adjon meg érvényes telefonszámot",
      invalidFormat: "Érvénytelen számformátum",
    },
  },
  text: {
    errors: {
      required:
        "Kérjük, csak betűket (A-Z), számokat (0-9) használjon, szimbólumokat ne",
      maxLength: "A bevitel túllépi a karakterkorlátot",
      minLength: "A bevitelnek legalább 2 karakternek kell lennie",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "Ez a mező kötelező",
    },
  },
  form: {
    errors: {
      generic: "Hiba történt az űrlap elküldésekor. Kérjük, próbálja újra.",
      reportAnIssue: "Kérjük, jelentse a problémát.",
      configuration: "Konfigurációs hiba",
      noFormQuestionsAvailable: "Nincsenek elérhető űrlap kérdések.",
      formComponentLoad:
        "Az űrlap komponens nem tölthető be a nem támogatott mező miatt.",
      code: "Kód",
      type: "Típus",
      missingRequiredFields:
        "Az űrlapból hiányoznak a kötelező mezők (E-mail és/vagy Hozzájárulás). Kérjük, lépjen kapcsolatba a rendszergazdával az űrlap konfigurációjának javításához.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Állatorvos",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Telepi egészségügyi szakember",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Állatvédő alapítványok/menhelyek",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Telep tulajdonos",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Ágazatvezető",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Telepvezető",
    id: "office_practice_manager",
  },
  {
    value: "OTC Retailer",
    label: "Kisállat szaküzlet tulajdonos/munkatárs",
    id: "otc_retailer",
  },
  { value: "Pharmacist", label: "Gyógyszerész", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Gyógyszertári asszisztens",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praxis tulajdonos, nem állatorvos",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Recepciós/ügyfélszolgálati munkatárs",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Termelő - Vegyes/Egyéb",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Kiskereskedő",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Juhtermelő",
    id: "sheep_producer",
  },
  {
    value: "SQP",
    label: "Kisállat szaküzlet e-kereskedelem tulajdonos/munkatárs",
    id: "sqp",
  },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Állatorvos",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Állatorvos", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Állatorvos/praxis tulajdonos",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Állatorvos asszisztens",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Állatorvosasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Állatorvosasema - Állatorvos",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Állatorvosasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Állatorvosasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Állatorvostan hallgató",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Állatorvos",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Nagykereskedő", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Úr",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Úr",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Asszony",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Asszony/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professzor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
